import { useState } from "react";
import { api, errMsg } from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { KeyRound } from "lucide-react";

export default function SettingsPanel() {
  const [form, setForm] = useState({ current_password: "", new_password: "", confirm: "" });
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    if (!form.current_password || !form.new_password) return toast.error("Fill both password fields");
    if (form.new_password !== form.confirm) return toast.error("New passwords don't match");
    if (form.new_password.length < 6) return toast.error("Password must be 6+ characters");
    setBusy(true);
    try {
      await api.post("/auth/change-password", {
        current_password: form.current_password,
        new_password: form.new_password,
      });
      toast.success("Password updated");
      setForm({ current_password: "", new_password: "", confirm: "" });
    } catch (e) {
      toast.error(errMsg(e, "Failed to change password"));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="max-w-xl">
      <Card className="border-black/10">
        <CardContent className="p-6">
          <div className="flex items-center gap-2 mb-4">
            <KeyRound className="w-4 h-4 text-forest" />
            <h2 className="text-lg font-semibold text-charcoal">Change password</h2>
          </div>
          <div className="space-y-4">
            <div>
              <Label>Current password</Label>
              <Input data-testid="current-password" type="password" value={form.current_password} onChange={(e) => setForm({ ...form, current_password: e.target.value })} />
            </div>
            <div>
              <Label>New password</Label>
              <Input data-testid="new-password" type="password" value={form.new_password} onChange={(e) => setForm({ ...form, new_password: e.target.value })} />
            </div>
            <div>
              <Label>Confirm new password</Label>
              <Input data-testid="confirm-password" type="password" value={form.confirm} onChange={(e) => setForm({ ...form, confirm: e.target.value })} />
            </div>
            <Button onClick={submit} disabled={busy} data-testid="change-password-btn" style={{ backgroundColor: "var(--forest)", color: "white" }}>
              {busy ? "Updating…" : "Update password"}
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
